import React from 'react';

export default function TopBar({ onNav }) {
  return (
    <div className="topbar">
      <div className="container">
        <div className="topbar-inner">
          <div className="topbar-left">
            <span>🎒</span>
            <span>Welcome to Basaveshwar Pre-Primary School, Belur-Chikkanasabi</span>
          </div>
          <div className="topbar-right">
            <span className="admission-badge">🔴 Admission Open 2026-27</span>
            <button className="topbar-link" onClick={() => onNav('gallery')}>Gallery</button>
            <button className="topbar-link" onClick={() => onNav('news')}>News &amp; Events</button>
            <button className="topbar-link" onClick={() => onNav('contact')}>Contact Us</button>
          </div>
        </div>
      </div>
    </div>
  );
}
